import i18n from 'i18n';
import { COLORS } from 'theme/constants';
import { CustomDomainVerificationStatus } from 'types/enums';

export const STATUS_TEXT_MAP = {
  [CustomDomainVerificationStatus.CONNECTED]: i18n.t('components.customDomains.domainStatusBadge.connected'),
  [CustomDomainVerificationStatus.VERIFIED]: i18n.t('components.customDomains.domainStatusBadge.verified'),
  [CustomDomainVerificationStatus.UNVERIFIED]: i18n.t('components.customDomains.domainStatusBadge.unverified'),
  [CustomDomainVerificationStatus.PENDING]: i18n.t('components.customDomains.domainStatusBadge.pendingVerification'),
  [CustomDomainVerificationStatus.FAILED]: i18n.t('components.customDomains.domainStatusBadge.failed'),
};

export const STATUS_COLOR_MAP = {
  [CustomDomainVerificationStatus.CONNECTED]: {
    textColor: '#30b96b',
    backgroundColor: '#e6f7ee',
  },
  [CustomDomainVerificationStatus.VERIFIED]: {
    textColor: '#30b96b',
    backgroundColor: '#e6f7ee',
  },
  [CustomDomainVerificationStatus.UNVERIFIED]: {
    textColor: COLORS.greyText,
    backgroundColor: '#e1e1e1',
  },
  [CustomDomainVerificationStatus.PENDING]: {
    textColor: COLORS.greyText,
    backgroundColor: '#e1e1e1',
  },
  [CustomDomainVerificationStatus.FAILED]: {
    textColor: '#f97673',
    backgroundColor: '#ffeaea',
  },
};
